import { component } from 'picoapp'

class Subscribe {
  constructor(node, ctx) {
    // bindings
    this.onSubmit = this.onSubmit.bind(this)
    this.onClickClear = this.onClickClear.bind(this)

    // selectors
    this._node = node
    this._form = this._node.querySelector('form')
    this._email = this._form.querySelector('input[type="email"]')

    this._clear_icons = Array.from(this._node.getElementsByClassName('clear-icon'))
    this._clear_icons.forEach((el) => el.addEventListener('click', this.onClickClear))


    // Add ID here to avoid pjax racing condition rendering 2 forms with same id on page transition...
    this._form.setAttribute('id', 'email_signup')

    // event listeners
    this._form.addEventListener('submit', this.onSubmit)
    KlaviyoSubscribe.attachToForms('#email_signup', {
      hide_form_on_success: false,
      $source: '$embed',
      $method_type: "Klaviyo Form",
      $method_id: 'embed',
      success: ($form, result) => {
        setTimeout(() => {
          this._node.classList.add('full-send')

          if (result.is_subscribed === false) {
            this._node.classList.add('success')
          } else if (result.is_subscribed === true) {
            this._node.classList.add('exists')
          } else if (!result.is_subscribed) {
            this._node.classList.add('fail')
          }
        }, 1332)
      }
    })

    // unmount
    return this.unmount.bind(this)
  }

  /**
   * Handle submit.
   */
  onSubmit(e) {
    document.activeElement.blur()
    this._node.classList.add('sending')
  }

  /**
   * Click to clear form.
   */
  onClickClear() {
    this._email.value = ''
    this._node.classList.remove('sending', 'full-send', 'success', 'exists', 'overheated', 'fail')
  }

  /**
   * Handle unmount.
   */
  unmount() {
    this._form.removeEventListener('submit', this.onSubmit)
    this._clear_icons.forEach((el) => el.removeEventListener('click', this.onClickClear))
  }
}

export default component((node, ctx) => new Subscribe(node, ctx))
